/** Columns the paginated permits list can be server-sorted by. All are Permit
 *  scalars (nested under orderBy: {permit: {...}}); computed or relation-backed
 *  columns (contractor, lastActivityAt) are deliberately excluded. */
export const PERMIT_SORT_FIELDS = [
	'issueDate',
	'permitNumber',
	'address',
	'region',
	'projectValue',
	'applicant',
	'typeOfWork',
] as const

export type PermitSortField = (typeof PERMIT_SORT_FIELDS)[number]
export type PermitSortOrder = 'asc' | 'desc'

export function isPermitSortField(value: string): value is PermitSortField {
	return (PERMIT_SORT_FIELDS as readonly string[]).includes(value)
}
